module.exports = {
  title: 'ERP价格查看',
  route: {
    path: '/seller-goods-manage',
    children: {
      path: 'erp-price-watch',
    },
  },
};
